import React from 'react';
import s from './TimeTravel.scss';

export interface Props {}

const TimeTravel: React.FC<Props> = () => {
  return <div className={s['root']}>Time Travel is active</div>;
};
TimeTravel.displayName = 'TimeTravel';

export default TimeTravel;
